import request from '@/utils/request'

const POLL_MS = 10000
const THROTTLE_MS = 3000

let inFlight = null
let lastFetchAt = 0
let cached = { waitCount: 0, copyCount: 0 }
const listeners = new Set()
let pollTimer = null
let pollRefCount = 0

function hasToken() {
  try {
    return !!sessionStorage.getItem('token')
  } catch (e) {
    return false
  }
}

function parseWaitExamineResult(res) {
  let wait = 0
  let copy = 0
  if (res && res.data && res.data.success) {
    const r = res.data.result
    if (r && typeof r === 'object') {
      wait = Number(r.waitCount != null ? r.waitCount : (r.waitExamineCount || 0)) || 0
      copy = Number(r.copyCount != null ? r.copyCount : 0) || 0
    } else if (typeof r === 'number') {
      wait = r
    } else if (typeof r === 'string') {
      wait = parseInt(r, 10) || 0
    }
  }
  return { waitCount: wait, copyCount: copy }
}

function notify() {
  const payload = { waitCount: cached.waitCount, copyCount: cached.copyCount }
  listeners.forEach((fn) => {
    try {
      fn(payload)
    } catch (e) {
      /* ignore listener error */
    }
  })
}

/**
 * 拉取待审/抄送数量；并发复用同一 Promise，短时间去重
 * @param {{ force?: boolean }} options force=true 绕过节流与进行中的复用
 */
export function fetchWaitExamineCount(options = {}) {
  const force = !!options.force

  if (!hasToken()) {
    cached = { waitCount: 0, copyCount: 0 }
    notify()
    return Promise.resolve({ ...cached })
  }

  const now = Date.now()
  if (!force && inFlight) return inFlight
  if (!force && lastFetchAt && now - lastFetchAt < THROTTLE_MS) {
    return Promise.resolve({ ...cached })
  }

  inFlight = request
    .get('/sys/approvalInitiation/getWaitExamineCount')
    .then((res) => {
      cached = parseWaitExamineResult(res)
      lastFetchAt = Date.now()
      notify()
      return { ...cached }
    })
    .catch(() => ({ ...cached }))
    .finally(() => {
      inFlight = null
    })

  return inFlight
}

/** 订阅数量变化，立即回调当前缓存 */
export function subscribeWaitExamineCount(fn) {
  if (typeof fn === 'function') {
    listeners.add(fn)
    fn({ ...cached })
  }
  return () => listeners.delete(fn)
}

/** 全局轮询：引用计数，仅首次启动时立即请求一次 */
export function startWaitExamineCountPoll() {
  pollRefCount += 1
  if (pollRefCount !== 1) return
  fetchWaitExamineCount()
  pollTimer = setInterval(() => {
    fetchWaitExamineCount()
  }, POLL_MS)
}

export function stopWaitExamineCountPoll() {
  pollRefCount = Math.max(0, pollRefCount - 1)
  if (pollRefCount === 0 && pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
}

/** 退出登录时重置 */
export function resetWaitExamineCount() {
  pollRefCount = 0
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
  inFlight = null
  lastFetchAt = 0
  cached = { waitCount: 0, copyCount: 0 }
  notify()
}



// WEBPACK FOOTER //
// ./src/utils/waitExamineCount.js